import { callApi } from './callApi';

export const getTranslations = (lang: string): Promise<string[]> => {
    return callApi('StorefrontAdminS3Url', 'GET', `/translations/${lang}.json`, null);
};
